var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"componentid":_vm.id}},[_c('input',{staticClass:"form-control",domProps:{"value":_vm.v},on:{"input":_vm.update}})])
}
var staticRenderFns = []

export { render, staticRenderFns }